import {useLayoutEffect, useState} from 'react';
import {paginateText} from './paginateText';

export default function useReasonPages(reasons, viewportRef, measureRef) {
    const [pagesByReason, setPagesByReason] = useState(() => new Map());
    const reasonsKey = JSON.stringify(reasons);

    useLayoutEffect(() => {
        const viewport = viewportRef.current;
        const measure = measureRef.current;
        if (!viewport || !measure) return;
        let disposed = false;

        function measurePages() {
            if (disposed || !viewport.clientWidth || !viewport.clientHeight) return;
            const pages = new Map([...new Set(JSON.parse(reasonsKey))].map(reason => [reason,
                paginateText(reason, text => {
                    measure.textContent = text;
                    return measure.getBoundingClientRect().height <= viewport.clientHeight;
                }),
            ]));
            measure.textContent = '';
            setPagesByReason(previous => JSON.stringify([...previous]) === JSON.stringify([...pages]) ? previous : pages);
        }

        measurePages();
        const observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(measurePages) : null;
        observer?.observe(viewport);
        window.addEventListener('resize', measurePages);
        document.fonts?.ready.then(measurePages);
        document.fonts?.addEventListener('loadingdone', measurePages);
        return () => {
            disposed = true;
            observer?.disconnect();
            window.removeEventListener('resize', measurePages);
            document.fonts?.removeEventListener('loadingdone', measurePages);
        };
    }, [reasonsKey, viewportRef, measureRef]);

    return pagesByReason;
}
